<template>
	<div class="wrapper">
		<div class="topTextWrapper">
			<div class="title"><span class="circle white"></span>已安装 电巢客户端</div>
			<div class="subTitle" v-show="isInTc">选择在 浏览器 中打开</div>
		</div>
		<div class="centerLogo">
			<div class="logoWrapper">
				<img src="../../assets/image/openApp/logo.png" class="logoImg">
			</div>
			<div class="logoText">电巢</div>
			<div class="slogan">
				专注电子工程技术
				<WxOpenTag :extinfo="target" ref="wxopentag" />
			</div>
		</div>
		<div class="bottomTextWrapper" v-show="!isInTc">
			<div class="openButton" @click="handleClick">打开电巢app</div>
		</div>
	</div>
</template>

<script>
import utils from '@/utils/utils'
import WxOpenTag from '@/components/WxOpenTag' 
export default {
	data(){
		return {
			isInTc: utils.browserChecker.isWx() || utils.browserChecker.isMobileQQ(),
			target: this.$route.query.target || ''
		}
	},
	mounted(){
		this.$refs.wxopentag.register()
	},
	methods: {
		handleClick(){
			utils.callNativeApp(encodeURIComponent(this.target))
		}
	},
	components: {
		WxOpenTag
	}
}
</script>

<style scoped>
.wrapper{
	position: relative;
	width: 100%;
	height: 100%;
	background-color: #fff;
	background-image: url("../../assets/image/openApp/background.jpeg");
	background-size: 100%;
	background-repeat: no-repeat;
}
.circle{
	display: inline-block;
	width: 15px;
	height: 15px;
	margin-right: 5px;
	background-size: contain;
	background-repeat: no-repeat;
}
.circle.white{
	background-image: url("../../assets/image/openApp/circle_white.png");
}
.circle.red{
	background-image: url("../../assets/image/openApp/circle_red.png");
}

.topTextWrapper{
	position: absolute;
	top: 65px;
	left: 40px;
	font-size: 16px;
	color: #fff;
}
.title{
	font-size: 22px;
	margin-bottom: 8px;
}
.subTitle{
	padding-left: 20px;
}

.centerLogo{
	display: flex;
	flex-direction: column;
	position: absolute;
	top: 250px;
	left: 50%;
	justify-content: center;
	align-items: center;
	transform: translateX(-50%);
}
.logoWrapper{
	width: 70px;
	height: 70px;
}
.logoImg{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.logoText{
	margin-top: 5px;
	font-size: 18px;
	font-weight: bold;
	color: #000;
	text-align: center;
}
.slogan{
	position: relative;
	margin-top: 5px;
	font-size: 16px;
	color: #626262;
	text-align: center;
}

.bottomTextWrapper{
	position: absolute;
	bottom: 50px;
	left: 40px;
}
.openButton{
	height: 35px;
	margin-left: 20px;
	padding: 0 18px;
	line-height: 35px;
	color: #fff;
	font-size: 16px;
	text-align: center;
	background-color: #f00;
	border-radius: 20px;
	cursor: pointer;
}

@media (max-width: 375px){
	.wrapper{
		width: 375px;
	}
}
@media (min-width: 550px){
	.wrapper{
		width: 550px;
		margin: 0 auto;
	}
}
@media (max-height: 600px){
	.centerLogo{
		top: 200px;
	}
}
</style>
